<div class="address-row">
  <div class="fieldName">
    {{fieldName}}:
  </div>

  <div class="inputField">
    <ng-container *ngIf="controlTpl; else defaultInput">
      <ng-container
        *ngTemplateOutlet="controlTpl; context: { value: operatorValue, setValue: setValue }">
      </ng-container>
    </ng-container>

    <ng-template #defaultInput>
      <input
        class="met-input"
        [ngModel]="operatorValue"
        (ngModelChange)="setValue($event)">
    </ng-template>
  </div>
</div>
